/*@ngInject*/
const PopupStateModel = function ($state) {

    let stateModelStorage,
        templateId;


    this.init = function () {
        stateModelStorage = {};
        templateId = null;
    };

    this.saveViewState = function (stateName, stateModel) {
        stateModelStorage[stateName] = _.cloneDeep(stateModel);
    };

    this.restoreViewState = function (stateName, viewModel) {
        let previousState = stateModelStorage[stateName];

        if(previousState) {
            return _.merge(viewModel, previousState);
        }
    };

    this.init();
};

angular.module('ums.configuration')
    .service('popupStateModel', PopupStateModel);
